export const UPDATE_DATA = "UPDATE_DATA";

export const RESET_STATE = "RESET_STATE";

// global module
export const UPDATE_IS_DEALER_MICRO_SITE = "UPDATE_IS_DEALER_MICRO_SITE";
export const UPDATE_DEALER_NAME = "UPDATE_DEALER_NAME";

export const CLEAR = "CLEAR";

// search module
export const ADD_MODEL = "ADD_MODEL";
export const REMOVE_MODEL = "REMOVE_MODEL";
export const UPDATE_MAX_PRICE_RANGE = "UPDATE_MAX_PRICE_RANGE";
export const UPDATE_PRICE_RANGE = "UPDATE_PRICE_RANGE";
export const UPDATE_PAYMENT_TYPE = "UPDATE_PAYMENT_TYPE";
export const UPDATE_YEAR = "UPDATE_YEAR";
export const ADD_TRANSMISSION = "ADD_TRANSMISSION";
export const REMOVE_TRANSMISSION = "REMOVE_TRANSMISSION";
export const ADD_FUEL_TYPE = "ADD_FUEL_TYPE";
export const REMOVE_FUEL_TYPE = "REMOVE_FUEL_TYPE";
export const UPDATE_DEALERS_LOCATIONS = "UPDATE_DEALERS_LOCATIONS";
export const UPDATE_REGIONS = "UPDATE_REGIONS";
export const SORT_BY_PRICE = "SORT_BY_PRICE";

// results module
export const ADD_MORE_CARS = "ADD_MORE_CARS";
export const INCREMENT_PAGE = "INCREMENT_PAGE";
export const RESET_PAGE = "RESET_PAGE";

// details module
export const CLEAR_CAR_INFO = "CLEAR_CAR_INFO";
